import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { routeNode, routerStore } from 'core/routing';

import { FourOhFour } from 'apps/fourOhFour';

import { Forum } from 'apps/forum/main';
import { Category } from 'apps/forum/category';
import { Thread } from 'apps/forum/thread';

const viewsMap = {
  '': Forum,
  category: Category,
  thread: Thread,
};

@observer
class ForumSpace extends React.Component {
  UNSAFE_componentWillMount() {
    const { params } = this.props;
    const thread = params.get('thread');
    // FIXME
    /*
     * Look for better ways of redirecting on load.
     * For this to work it needs to be here, later in the router hierarchy.
     */
    if (!!thread && !routerStore.previousRoute) {
      routerStore.router.navigate(
        'initiative.forum.thread',
        {
          initiative: params.get('initiative'),
          threadId: thread,
        },
        { replace: true },
      );
    }
  }

  render() {
    const View = this.props.componentFromRoute();
    const { params } = this.props;
    return (
      <View
        params={params}
        routeName={this.props.route.name}
        initiativeManager={this.props.initiativeManager}
      />
    );
  }
}

ForumSpace.propTypes = {
  route: PropTypes.object,
  params: PropTypes.object,
  componentFromRoute: PropTypes.func,
  initiativeManager: PropTypes.object,
};

export const ForumRouter = routeNode(
  'initiative.forum',
  viewsMap,
  FourOhFour,
)(ForumSpace);
